// extracted by mini-css-extract-plugin
export var box = "_3w-1";
export var checkboxRow = "_3w-8";
export var checked = "_3w-2";
export var descriptionSpacer = "_3w-a";
export var disabled = "_3w-3";
export var icon = "_3w-6";
export var input = "_3w-0";
export var labelSpacer = "_3w-9";
export var medium = "_3w-5";
export var small = "_3w-4";
export var text = "_3w-7";